import { supertypeClass, property } from '@haventech/amorphic';
import { Policy } from './Policy';
import { IsomorphicPersistent } from '@hit/amorphic-types/index';

@supertypeClass({ toClient: true, toServer: false })
export class IllustrationRequestProperty extends IsomorphicPersistent {
  @property({ getType: () => Policy })
  policy: Policy;

  @property({ rule: ['required'], comment: `A human-readable key for this property` })
  property: string;

  @property({
    rule: ['required'],
    comment: `Indicates if this is associated with the original or Revised Basic Illustration`,
  })
  illustrationType: 'originalBasicIllustration' | 'revisedBasicIllustration';

  @property()
  stringValue: string;

  @property()
  numberValue: number;

  @property()
  booleanValue: boolean;

  @property()
  dateValue: Date;

  constructor() {
    super();
  }

  static new(policy) {
    return new IllustrationRequestProperty().init(policy);
  }

  init(policy) {
    this.policy = policy;
    return this;
  }
}
